import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function VerifyPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [verifyCode, setVerifyCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleVerify = async () => {
    if (!verifyCode.trim()) {
      setError(t('verify.errorEmpty'));
      return;
    }

    setLoading(true);
    setError('');

    try {
      // 模拟验证请求
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // 验证成功后跳转到详情页
      navigate(`/nft-detail?code=${verifyCode}`);
    } catch (err) {
      setError(t('verify.errorFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-50 pt-24 pb-16">
      <div className="max-w-2xl mx-auto px-4">
        {/* 标题区域 */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-2xl mb-6 shadow-lg">
            <i className="ri-shield-check-line text-4xl text-white"></i>
          </div>
          <h1 className="text-4xl font-bold text-slate-900 mb-4">
            {t('verify.title')}
          </h1>
          <p className="text-lg text-slate-600">
            {t('verify.subtitle')}
          </p>
        </div>

        {/* 验证卡片 */}
        <div className="bg-white rounded-2xl shadow-xl border border-slate-200 p-8 mb-8">
          <div className="mb-6">
            <label className="block text-sm font-semibold text-slate-700 mb-3">
              {t('verify.inputLabel')}
            </label>
            <input
              type="text"
              value={verifyCode}
              onChange={(e) => {
                setVerifyCode(e.target.value);
                setError('');
              }}
              placeholder={t('verify.inputPlaceholder')}
              className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-base"
            />
            {error && (
              <p className="mt-2 text-sm text-red-600 flex items-center">
                <i className="ri-error-warning-line mr-1"></i>
                {error}
              </p>
            )}
          </div>

          <button
            onClick={handleVerify}
            disabled={loading}
            className="w-full bg-gradient-to-r from-teal-500 to-emerald-500 text-white py-3 rounded-lg font-semibold hover:from-teal-600 hover:to-emerald-600 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <i className="ri-loader-4-line animate-spin mr-2"></i>
                {t('verify.verifying')}
              </span>
            ) : (
              t('verify.verifyButton')
            )}
          </button>
        </div>

        {/* 说明区域 */}
        <div className="bg-teal-50 border border-teal-200 rounded-xl p-6">
          <div className="flex items-start">
            <i className="ri-information-line text-2xl text-teal-600 mr-3 mt-1"></i>
            <div>
              <h3 className="font-semibold text-teal-900 mb-2">
                {t('verify.infoTitle')}
              </h3>
              <ul className="space-y-2 text-sm text-teal-800">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 mr-2 mt-0.5"></i>
                  <span>{t('verify.info1')}</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 mr-2 mt-0.5"></i>
                  <span>{t('verify.info2')}</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 mr-2 mt-0.5"></i>
                  <span>{t('verify.info3')}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
